import { Api } from "./Api";

  export const getNationDetails = async () => {
    try {
      const response = await Api.get(
        `/tenant`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting environment:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting environment:', error.message);
        return { error: 'An error occurred while getting the environment.' };
      }
    }
  };
  export const fetchTileDetails = async () => {
    try {
      const response = await Api.get(
        `/experience/dashboard/stats`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error dashboard details:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error dashboard details:', error.message);
        return { error: 'An error occurred while dashboard details.' };
      }
    }
  };

 export const getUserDetails = async (userId: any) => {
    try {
      const response = await Api.get(
        `/user/${userId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error dashboard details:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error dashboard details:', error.message);
        return { error: 'An error occurred while dashboard details.' };
      }
    }
  };